import { ROLES } from "../../../../../helpers/commons.helpers";
/**
 * Tools route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ToolRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/help",
        name: "Help",
        meta: {
            title: "Help",
            modules: ["help"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(/* webpackChunkName: "help" */ "@/modules/tools/modules/helps/pages/Help")
    },
    {
        path: "/help/:moduleSlug",
        name: "HelpResults",
        meta: {
            title: "Help Results",
            modules: ["help"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "helpResults" */ "@/modules/tools/modules/helps/pages/HelpResults"
            )
    },
    {
        path: "/help/:moduleSlug/:documentSlug",
        name: "HelpDetails",
        meta: {
            title: "Help Details",
            modules: ["help"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "HelpDetails" */ "@/modules/tools/modules/helps/pages/HelpDetails"
            )
    }
]